<template>
  <div class="charge-box">
    <app-header title="充值" @goback="goBack">
      <div slot="tips" class="charge-tips" @click="intoRecord">
        <span>充值记录</span>
      </div>
    </app-header>
    <div class="tab-box">
      <div :class="{'active-tab': item.value === currentTab.value}" v-for="item in tabList" :key="item.value" @click="changeTab(item)"><span>{{item.name}}</span></div>
    </div>
    <transition-group :name="currentTab.value === 1? 'slide-in' : 'slide-out'" mode="out-in">
      <charge-online v-show="currentTab.value === 1" key="online"></charge-online>
      <charge-public v-show="currentTab.value === 2" key="public"></charge-public>
    </transition-group>
  </div>
</template>

<script>
import AppHeader from 'components/app-header';
import chargeOnline from './components/charge-online';
import chargePublic from './components/charge-public';

export default {
  components: {
    AppHeader,
    chargeOnline,
    chargePublic,
  },
  data() {
    return {
      tabList: [
        { name: '在线支付', value: 1 },
        { name: '对公转账', value: 2 },
      ],
      currentTab: { name: '在线支付', value: 1 },
    }
  },
  methods: {
    goBack() {
      this.$router.push({name: 'home'});
    },
    changeTab(item) {
      this.currentTab = item;
    },
    intoRecord() {
      this.$router.push({name: 'charge-record'});
    }
  }
}
</script>

<style src="./charge.scss" lang="scss" scoped></style>

